import React, { Component } from "react";
import "./modal.scss";
import { Row, Grid, Col, Button } from "react-bootstrap";
import ImportFormWrapper from "../pages/shows/import_form_wrapper";
import BaseModal from "./base_modal";
import Divider from "../lib/divider";
import LoadingButton from "../forms/loading_button/loading_button";
import { If } from "react-extras";

class ImportModal extends Component {
  state = {
    confirmed: false,
  };

  close = () => {
    this.props.history.push(this.props.closeRoute());
    this.props.closeModal();
  };

  content = () => {
    return (
      <Grid fluid>
        <Row>
          <Col md={6} xs={12}>
            <h3 className="import-podcast-header">Select Your Podcast</h3>
            <p>Search for your podcast or provide us with a link to its RSS feed.</p>
            <h3 className="import-podcast-header">We{"'"}ll Import Your Content</h3>
            <p>
              Over a few minutes, RedCircle will import your entire back catalog of episodes,
              images, descriptions, etc. Nothing will change for your listeners and your existing
              hosting provider will work as it does today.
            </p>
            <h3 className="import-podcast-header">Redirect Your Listeners</h3>
            <p>
              Once the import is complete, you'll return to your existing podcast hosting provider
              and set up a redirect. If you have any trouble, we'll be right there to help you
              through the process.
            </p>
          </Col>
          <Col md={6} xs={12}>
            <ImportFormWrapper
              onSubmit={() => {
                this.close();
              }}
              close={this.close}
            />
            <Divider smallMargin />
            <If condition={Boolean(this.props.currentRSSValue)}>
              <div className="import-podcast-checkbox-content">
                <input
                  type="checkbox"
                  className="form-control import-podcast-checkbox"
                  onChange={e => {
                    this.setState({ confirmed: e.target.checked });
                  }}
                />
                I certify that I own the rights to this podcast and am in compliance with our{" "}
                <a target="_blank" href="https://redcircle.com/terms" rel="noopener noreferrer">
                  Terms of Service
                </a>
                .
              </div>
            </If>
          </Col>
        </Row>
      </Grid>
    );
  };

  footer = () => {
    return (
      <Grid fluid>
        <Row>
          <Col mdOffset={1} md={5} xs={6}>
            <Button
              className="btn-secondary btn-large import-modal__submit-button"
              onClick={this.close}>
              Cancel
            </Button>
          </Col>
          <Col md={5} xs={6}>
            <LoadingButton
              isLoading={this.props.isLoading}
              Button={Button}
              disabled={!this.state.confirmed}
              className="btn-primary btn-large import-modal__submit-button"
              onClick={this.props.submitForm}>
              Import
            </LoadingButton>
          </Col>
        </Row>
      </Grid>
    );
  };

  render() {
    return (
      <BaseModal
        columns={12}
        offset={0}
        title="Import Podcast"
        close={this.close}
        showContent={true}
        Content={this.content}
        Footer={this.footer}
      />
    );
  }
}

export default ImportModal;
